






















import Vue from 'vue';
import Component from 'vue-class-component';
import marked from 'marked';

import UnityBridge from '@/unity-bridge';

@Component
export default class SettingsPage extends Vue {

    public unityVersion: string = '?';

    private unityBridge: UnityBridge;

    public async mounted() {
        await this.$nextTick();
        this.$$('.imprint a').addClass('external');

        this.unityBridge = new UnityBridge();
        this.unityBridge.addMessageHandler('unityVersion', e => this.onUnityVersion(e));
        this.unityBridge.send('getVersion');
    }

    public beforeDestroy() {
        this.unityBridge.destroy();
    }

    public get imprintText() {
        const sourceText = this.$t('imprint.text');
        if (!sourceText) return '';
        return marked(sourceText);
    }

    public get appVersion(): string {
        return this.$f7.version;
    }

    public onUnityVersion(event: any) {
        if (event && event.detail) {
            this.unityVersion = event.detail;
        }
    }
}
